import { makeStyles } from 'tss-react/mui';

export const useContactsCardStyles = makeStyles()(() => ({
  card: {
    height: '100%',
  },
  hwLogo: {
    height: '2.4rem',
    width: 'auto',
  },
  loadingBox: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '5rem',
  },
  email: {
    textDecoration: 'underline',
    '&:hover': {
      textDecoration: 'none',
      cursor: 'pointer',
    },
  },
}));
